import { memo } from "react";
import { C } from "@/lib/colors";

interface Props {
  ok: boolean;
  label: string;
  href?: string;
  title?: string;
}

/**
 * Semantic colors: open = mint (positive), closed = amber (warning, not
 * error). Red is reserved for "sell" semantics in the trading palette.
 */
export const StatusChip = memo(function StatusChip({ ok, label, href, title }: Props) {
  const Wrapper = href ? "a" : "span";
  const fg = ok ? C.mint : C.amber;
  const bg = ok ? "rgba(0, 215, 142,0.06)" : C.amberBg;
  const border = ok ? "rgba(0, 215, 142,0.15)" : "rgba(242, 181, 83,0.2)";
  return (
    <Wrapper
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      title={title ?? `${label}: ${ok ? "open" : "CLOSED"}`}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex cursor-pointer items-center font-mono-num no-underline transition-[filter,color] hover:brightness-125"
      style={{
        gap: 2,
        padding: "2px 6px",
        fontSize: 10,
        fontWeight: 700,
        color: fg,
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 4,
      }}
    >
      {label}
      <span style={{ fontSize: 10 }}>{ok ? "✓" : "✕"}</span>
    </Wrapper>
  );
});
